<template>
  <b-card
    class="chat-block-preview"
  >
    <player-chat-block-link
      :playerId="playerId"
      :chatBlockId="object.id"
    />

    <table>
      <tr>
        <th>Blocker</th>
        <td>
          <user-link
            :user="getUser(object.userId)"
          />
        </td>
      </tr>
      <tr>
        <th>Begin</th>
        <td>{{object.ctime | getMomentMinStr}}</td>
      </tr>
      <tr>
        <th>Planned duration</th>
        <td>{{getPlannedDurationStr}}</td>
      </tr>
      <tr>
        <th>Planned end</th>
        <td>{{object.ftime | getMomentMinStr}}</td>
      </tr>
    </table>

  </b-card>
</template>

<script>
import { getUserFromMap } from '../model/user';
import { getPlayerChatBlockPlannedDurationStr } from '../model/player-chat-block-log';

import UserLink from './UserLink.vue';
import PlayerChatBlockLink from './PlayerChatBlockLink.vue';

export default {
  name: 'PlayerChatBlockPreview',

  components: {
    PlayerChatBlockLink,
    UserLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    object: {
      type: Object,
      required: true,
    },

    userMap: {
      type: Map,
      required: true,
    },
  },

  computed: {
    getPlannedDurationStr() {
      return getPlayerChatBlockPlannedDurationStr(this.object);
    },
  },

  methods: {
    getUser(userId) {
      return getUserFromMap(this.userMap, userId);
    },
  },
};
</script>

<style scoped>
.chat-block-preview .card-body {
  padding: 8px;
}

.chat-block-preview th {
  padding-right: .5rem;
}
</style>
